module.exports = __webpack_public_path__ + "img/search-grey-icon.ee1802c6.svg";